module.exports = __webpack_public_path__ + "static/img/publicity-btn1.78d382e.png";


//////////////////
// WEBPACK FOOTER
// ./static/publicity-btn1.png
// module id = U5ue
// module chunks = 1